import { useTranslate } from '@i18n';
import { SwitchGroup, Button, colors } from '@ui';

import { LAYOUT_CREATE_MODE } from './useCreateLayout';

interface FooterSecondaryControlsProps {
    isAddingLayout: boolean;
    changeCreateMode: (mode: string) => void;
    startAddingLayout: () => void;
}

const footerOptions = [
    { label: 'Copy Selected Layout', value: LAYOUT_CREATE_MODE.COPY_SELECTED },
    { label: 'Create Blank', value: LAYOUT_CREATE_MODE.CREATE_NEW },
] as const;

export function FooterSecondaryControls({
    isAddingLayout,
    changeCreateMode,
    startAddingLayout,
}: FooterSecondaryControlsProps) {
    const t = useTranslate();
    if (isAddingLayout) {
        return (
            <SwitchGroup
                options={footerOptions}
                defaultValue={LAYOUT_CREATE_MODE.COPY_SELECTED}
                onClick={changeCreateMode}
            />
        );
    }
    return (
        <Button
            variant="secondary"
            size="medium"
            rounded
            icon="plus-circle"
            iconSide="before"
            iconSize={18}
            iconWeight="fill"
            iconColor={colors.blue[500]}
            onClick={startAddingLayout}
        >
            {t('generic_ui.add_layout')}
        </Button>
    );
}
